// import Calendar from "@/utils/calendar";

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "批次包号",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "商品图片",
    dataIndex: "regionName",
    key: "regionName",
    scopedSlots: {
      customRender: 'image'
    }
  },
  {
    title: "平台SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "商品规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  {
    title: "数量",
    dataIndex: "amount",
    key: "amount",
  },
];

export const dataSource = [
  {
    "amount": 0,
		"beactive": 0,
		"checkedAmount": 0,
		"checkingShelvFlag": 0,
		"checkingShelvedAmount": 0,
		"combinationProductItemFlag": 0,
		"createTime": "",
		"creater": 0,
		"customerShopId": 0,
		"customerShopName": "",
		"dictateOrderCode": "",
		"dutyCode": "",
		"dutyName": "",
		"exceptionCode": 0,
		"exceptionRelation": "",
		"expressNo": "",
		"gridCode": "",
		"id": 0,
		"isRoot": 0,
		"itemCategory": "",
		"lmt": "",
		"modifier": 0,
		"oemProductClassificationId": 0,
		"operationType": 0,
		"orderCode": "",
		"orderType": 0,
		"originAmount": 0,
		"parentCode": "",
		"picRelation": "",
		"pickable": 0,
		"pkgCode": "2",
		"pkgOwn": 0,
		"pkgType": 0,
		"platformOrderNo": "",
		"productImg": "",
		"productLink": "",
		"productName": "",
		"productProp": "",
		"productSku": "",
		"productType": 0,
		"purchaseNo": "",
		"purchaseType": 0,
		"regionCode": "",
		"remark": "",
		"rootCode": "",
		"settled": 0,
		"shopProductSku": "",
		"status": 0,
		"stockCode": "",
		"stockable": 0,
		"systemSource": 0,
		"urgent": 0,
		"warehouse": ""
  },
];
